import { isNew } from 'site-modules/shared/utils/publication-states';
import { withTargetText } from 'site-modules/shared/utils/url-utils';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { objectToQueryString } from 'site-modules/shared/utils/string';

export function getOpinionSourceUrl({ vehicle, labelText, expandedEntryId }) {
  const url = getCoreUrl(
    { makeSlug: vehicle.make.slug, modelSlug: vehicle.model.slug, year: vehicle.year },
    !isNew(vehicle.pubStates)
  );
  const params = objectToQueryString({ expandedEntryId });
  const urlWithParams = `${url}${params ? `?${params}` : ''}`;

  return withTargetText(urlWithParams, { text: labelText });
}
